:host {
  cursor: pointer;
}

.viewer-button {
  align-items: center;
  background: none;
  border: none;
  color: inherit;
  cursor: inherit;
  display: flex;
  padding: 0;
}
